export default __webpack_public_path__ + "static/media/CSI.0e049b5a.pdf";